import moment from "moment";

export const isValidReportRange = (start, end) => {
  const first = moment(start, "YYYY-MM-DD", true);
  const last = moment(end, "YYYY-MM-DD", true);
  return first.isValid() && last.isValid() && !first.isAfter(last, "day");
};

// A half-open interval includes every timestamp on the final selected day.
export const reportDateCondition = (column, start, end) => {
  if (!isValidReportRange(start, end)) throw new Error("Invalid report date range");
  return `${column} >= '${moment(start).format("YYYY-MM-DD")}' AND ${column} < '${moment(end).add(1, "day").format("YYYY-MM-DD")}'`;
};

export const buildVansaleWhere = ({ start, end, rows, includeAdmin, company }) => {
  const range = reportDateCondition("PK_H.Doc_Date", start, end);
  const conditions = [];
  if (rows.length) {
    // Keep date, delivery line and round together; independent IN lists
    // would also include combinations the user did not select.
    const groups = new Map();
    rows.forEach((row) => {
      const key = `${Number(row.Delivery_Line_Id)}:${Number(row.PK_Round)}`;
      if (!groups.has(key)) groups.set(key, { line: Number(row.Delivery_Line_Id), round: Number(row.PK_Round), days: new Set() });
      groups.get(key).days.add(moment(row.Doc_Date).format("YYYY-MM-DD"));
    });
    const selections = [];
    groups.forEach(({ line, round, days }) => {
      const intervals = [];
      [...days].sort().forEach((day) => {
        const previous = intervals[intervals.length - 1];
        if (previous && moment(previous.end).add(1, "day").format("YYYY-MM-DD") === day) previous.end = day;
        else intervals.push({ start: day, end: day });
      });
      // Compact consecutive selected days to keep monthly print URLs short,
      // while preserving any unchecked days as gaps.
      intervals.forEach((interval) => selections.push(`(${reportDateCondition("PK_H.Doc_Date", interval.start, interval.end)} AND PK_H.Delivery_Line_Id = ${line} AND PK_H.PK_Round = ${round})`));
    });
    conditions.push(`(${range} AND PK_H.Comp_Id = ${Number(company)} AND PK_H.Doc_Status = 5 AND SO_H.Doc_Status <> 13 AND (${selections.join(" OR ")}))`);
  }
  if (includeAdmin) {
    conditions.push(`(SO_H.Doc_Is_PickingList = 0 AND ${reportDateCondition("SO_H.Doc_Date", start, end)} AND SO_H.Comp_Id = ${Number(company)} AND SO_H.Doc_Status <> 13)`);
  }
  return conditions.length ? ` AND (${conditions.join(" OR ")})` : " AND 1 = 0";
};
